const ensureMeta = (name) => {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  return meta;
};

export const applySeo = ({ title, description }) => {
  if (title) document.title = title;
  if (description) {
    const meta = ensureMeta("description");
    meta.setAttribute("content", description);
  }
};
